<template>
  <div>
    <div class="font-bold text-2xl text-center p-3">
        Đối tác của FastMoney
    </div>
    <div class="grid grid-cols-2">
        <div class=" bactive p-3 rounded-md flex text-center m-auto md:col-span-1 col-span-2 mt-1">
            <img src="@/assets/default_main/ld_fm/p1.png" alt="partner logo1" />
            <div class="ml-3 text-left">
              <div class="font-bold-vmain color-vmain2">
                  EVN Finance
              </div>
              <div class="text-xs">
                  Đối tác cung cấp sản phẩm vay
              </div>
            </div>
        </div>

        <div class="bactive p-3 rounded-md flex text-center m-auto md:col-span-1 col-span-2 mt-1">
            <img class="teft-right float-right" src="@/assets/default_main/ld_fm/p2.png" alt="partner logo1" />
            <div class="ml-3 text-left">
              <div class="font-bold-vmain color-vmain2">
                  Amber Fintech
              </div>
              <div class="text-xs">
                  Cung cấp nền tảng phân tích, quản lý khách hàng
              </div>
            </div>
        </div>
        <!-- <div class="grid grid-cols-2 text-center m-auto">
            <img src="@/assets/default_main/ld_fm/p2.png" alt="partner logo2" />
            <div class="">
              <div class="font-bold-vmain color-vmain2">
                  Amber Fintech
              </div>
              <div class="text-xs">
                  Cung cấp nền tảng phân tích, quản lý khách hàng
              </div>
            </div>
        </div> -->
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>